import styled from "styled-components";
import { Tab } from "@vds/tabs";
import { DropdownSelect } from "@vds/selects";
import { DatePicker } from "@vds/date-pickers";
import { Button } from "@vds/buttons";
import { Line } from "@vds/lines";

export const DashboardWrapper = styled.div``;

export const DashBoardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 18px;
  border-bottom: 1px solid lightgray;
`;

export const Dashboard = styled.div`
  margin-left: 30px;
  margin-top: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #333333;
`;

export const BreadCrumb = styled.div`
  margin-right: 30px;
  margin-top: 20px;
`;

export const CustomTab = styled(Tab)`
  padding-right: 20px;
`;

export const CustomTabNth = styled(CustomTab)`
  visibility: hidden;
`;

export const TabView = styled.div`
  margin-right: 30px;
  margin-left: 30px;
  margin-top: 10px;
`;

export const SPWrapper = styled.div`
  border: 1px solid lightgray;
  border-radius: 10px;
  margin-top: -1px;
  margin-left: -13px;
  margin-right: -13px;
  padding-bottom: 50px;
`;

export const FlexRow = styled.div`
  margin-top: 10px;
  margin-left: 20px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 600px) {
    margin-left: 5px;
    gap: 8px;
    flex-direction: column;
  }
`;
export const Row = styled.div`
  margin-top: 10px;
  margin-left: 20px;
  display: flex;
  align-items: center;
`;
export const FlexColumn = styled.div`
  display: flex;
  align-items: center;
  width: 335px;
  justify-content: space-around;
  margin-right: 25px;
`;

export const FlexCol = styled.div`
  margin-left: 8%;
  display: flex;
  align-items: center;
`;

export const Label = styled.div`
  width: 45%;
`;
export const TextLabel = styled.div`
  width: 40%;
  margin-left: 15px;
`;

export const ToLabel = styled.div`
  width: 47%;
  margin-left: -35px;
`;

export const CustomDropdownSelect = styled(DropdownSelect)`
  & div {
    & div {
      border-radius: 4px !important;
      border: 1px solid;
    }
  }
  /* .gUuvib {
    border-radius: 20px;
    width: 150%;
  } */
  /* width: 160%; */
`;

export const CustomDatePicker = styled(DatePicker)`
  margin-left: -5px;
  & span {
    border-radius: 4px !important;
    border-color: rgb(0, 0, 0);
  }
`;

export const CustomButton = styled(Button)`
  width: 145px;
  height: 42px;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 5%;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 700;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 15px;
  width: 200px;
  height: 118px;
  background-color: #f6f6f6;
  border-radius: 15px;
`;

export const ListLabel = styled.div`
  margin-left: 20px;
  margin-top: 15px;
  word-break: break-word; /* Break long words */
  max-width: 15rem; /* Prevent overflow */
`;

export const ListCount = styled.div`
  margin-left: 20px;
  margin-top: 12px;
  font-size: 32px;
  font-weight: 700;
  word-break: break-word;
`;

export const Heading = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-top: 2.8rem;
  margin-left: 17px;
`;

export const CustomLine = styled(Line)`
  width: 97.5%;
  margin-left: 17px;
  margin-top: 10px;
  background-color: black;
`;

export const ButtonRow = styled.div`
  margin-top: 50px;
  display: flex;
`;

export const ButtonCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: left;
  gap: 3rem;
`;

export const CountHeading = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-top: 2.8rem;
  margin-left: 45px;
  letter-spacing: 0.1rem;
  background-color: lightgoldenrodyellow;
`;

export const ComparisionViewButton = styled(Button)`
  width: 395px;
  font-size: 14px;
  font-weight: 700;
  color: black;
  background-color: ${(props) => (props.isChartShow ? "black" : "white")};
  color: ${(props) => (props.isChartShow ? "white" : "black")};
`;

export const MainWrapper = styled.div`
  display: block;
`;

export const TableWrapper = styled.div`
  .customerTable {
    th .p-column-title {
      font-size: 18px;
      font-weight: 700;
      font-family: neue-haas-grotesk-text;
    }

    th .p-datatable-thead {
      border-bottom: 2px solid red;
    }
  }
  margin-top: 30px;
  background-color: white;
  width: 600px;
  height: 400px;
  overflow: auto;
`;

export const ChartWrapper = styled.div`
  margin-top: 30px;
  background-color: white;
`;

const SpacerHelper = styled.div((props) => {
  let style = {};
  if (props.top) {
    style.paddingTop = props.top;
  }
  if (props.bottom) {
    style.paddingBottom = props.bottom;
  }
  if (props.left) {
    style.paddingLeft = props.left;
  }
  if (props.right) {
    style.paddingRight = props.right;
  }
  if (props.width) {
    style.width = props.width;
  }
  if (props.height) {
    style.height = props.height;
  }
  return style;
});

/**
 * Spacer div
 * @param {{top: string, bottom: string, left: string, right: string, width: string, height: string}} props Corresponding values for padding
 */
export const Spacer = (props) => <SpacerHelper {...props} />;

export const CFSTheading = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin: 25px 16px 0px 16px;
  background-color: lightgray;
  border-radius: 7px;
  padding: 7px;
`;

export const CFSTlistItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 7px;
  margin-top: 7px;
  width: 14rem;
  height: 108px;
  background-color: #f6f6f6;
  border-radius: 15px;
  // overflow: auto; /* Prevent overflow */
`;

export const FlexRowWithBorder = styled(FlexRow)`
  display: flex;
  flex-direction: row;
  border: 1px solid #000000;
  border-radius: 7px;
  padding-bottom: 16px;
  margin: 15px 10px 10px 10px;
`;

export const CustomCFSTheading = styled(CFSTheading)`
  width: 205px;
  background-color: #ffffff;
  margin-top: 6.5%;
  text-align: center;
`;

function getAlertColor(alertColor) {
  if (alertColor > 100) {
    return "#f85766";
  }
  if (alertColor >= 50) {
    return "#f09865ff";
  }
  if (alertColor >= 25) {
    return "#f9e070";
  }
  return "#f6f6f6";
}

export const CustomCFSTlistItem = styled(CFSTlistItem)`
  width: ${(props) => (props.width ? "500px" : "220px")};
  background-color: ${(props) => getAlertColor(props.alertColor)};
  cursor: ${(props) => (props.alertColor >= 25 ? "pointer" : "default")};
`;

export const CustomSpan = styled.span`
  margin: 10px 12px;
  background-color: #fbe4d7;
  border-radius: 5px;
  padding: 5px 0px;
  width: 100%;
`;

export const CustomImg = styled.img`
  margin: 0px 7px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CustomErrBlock = styled.div`
  margin: 10px 16px;
  background-color: #fbe4d7;
  border-radius: 5px;
  padding: 5px 0px;
`;
